/** A goal's page, opened from the Goals list's suggestion that just created it. */
export type GoalSearch = {
  fromAiRecommendation?: boolean;
};

/** The param as `validateSearch` receives it, unparsed. */
type UnvalidatedGoalSearch = {
  fromAiRecommendation?: unknown;
};

/** Declared so the router keeps the param; any value but `true` reads as absent. */
export function validateGoalSearch(search: UnvalidatedGoalSearch): GoalSearch {
  return search.fromAiRecommendation === true || search.fromAiRecommendation === 'true'
    ? { fromAiRecommendation: true }
    : {};
}
